module.exports = __webpack_public_path__ + "static/c47a6af684e734b4b28bf8e957db41df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iphone.png
// module id = 500
// module chunks = 0